import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-rows-01',
  imports: [],
  templateUrl: './rows-01.html',
  styleUrl: './rows-01.scss',
})
export class Rows01 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
